import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslationManagerNavigationService {
  private readonly clearFiltersSubject = new Subject<void>();
  private hasPendingClearFiltersRequest = false;
  readonly clearFilters$ = this.clearFiltersSubject.asObservable();

  requestClearFilters(): void {
    this.hasPendingClearFiltersRequest = true;
    this.clearFiltersSubject.next();
  }

  consumePendingClearFiltersRequest(): boolean {
    if (!this.hasPendingClearFiltersRequest) {
      return false;
    }

    this.hasPendingClearFiltersRequest = false;
    return true;
  }
}
